'use strict';

var _ = require('lodash');
var ChartSponsorForecastMarketDataProviderService = function ChartSponsorForecastMarketDataProviderService($filter, dataRetrieverService, constants, momentService, featureToggleService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function retrieveData(market, departureDateFrom, departureDateTo) {
    var rqlQuery = '((origin=="' + market.origin + '";' + 'destination=="' + market.destination + '");' + '(pointOfSales.posName=="' + market.spos + '");' + '(departureDate=ge="' + departureDateFrom.toISOString() + '";' + 'departureDate=le="' + departureDateTo.toISOString() + '"))';
    return dataRetrieverService.getDataRetriever(constants.SCHEDULE_CHANGE_SCREEN, constants.SPONSOR_FORECAST_MARKET_MODE).retrieveSimpleData(constants.SPONSOR_FORECAST_MARKET_MODE, rqlQuery);
  }

  /**
   * SponsorMarketTransformerFactory will be used to transform and limit the amount of data kept in cache.
   * @param selectedMetric
   * @param data that will be transformed
   * @returns {*}
   */
  function transformData(selectedMetric, data) {
    var isMappedFeatureDisabled = featureToggleService.isDisabled('MAPPED_MODE');
    var MAPPING = {
      'Bookings': {
        'm1': isMappedFeatureDisabled ? 'mappedReservationHoldingsTotal' : 'regularReservationHoldingsTotal'
      },
      'Revenue': {
        'm1': isMappedFeatureDisabled ? 'mappedRevenueTotal' : 'regularRevenueTotal'
      },
      'Demand': {
        'm1': isMappedFeatureDisabled ? 'mappedRemainingDemandFC' : 'regularRemainingDemandFC'
      }
    };
    var metricMapping = MAPPING[selectedMetric];
    if (data === undefined) {
      return undefined;
    }
    return data.map(function (d) {
      var obj = Object.create(null);
      obj.m1 = d[metricMapping.m1];
      obj.d1 = d.departureDate;
      obj.stackLabel = rmMomentFormat(d.departureDate, 'DATE_ISO');
      return obj;
    });
  }
  function getData(market, selectedMetric) {
    var departureDateFrom = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(1, 'years');
    var departureDateTo = momentService.now(momentService.FIELD.DEPARTURE_DATE);
    return retrieveData(market, departureDateFrom, departureDateTo).then(_.wrap(selectedMetric, transformData));
  }
  return {
    getData: getData
  };
};
ChartSponsorForecastMarketDataProviderService.$inject = ['$filter', 'DataRetrieverService', 'DataRetrieverConstantsService', 'MomentService', 'FeatureToggleService'];
module.exports = ChartSponsorForecastMarketDataProviderService;